import {Component, Input, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {PaycardModel} from '../../../services/paycard/paycard.model';
import {DeletePaycard, GetPaycardDetail, ResetPaycardPin} from '../../../../state/actions/appState.paycards.actions';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RequestConfirmation} from '../../../../state/actions/appState.actions';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs';

@Component({
  selector: 'app-paycard-detail',
  templateUrl: './paycard-detail-modal.component.html',
  styleUrls: ['./paycard-detail-modal.component.scss']
})
export class PaycardDetailModalComponent implements OnDestroy {
  @Input() paycard: PaycardModel;
  @Input() paycardId: string;

  constructor(
    private store: Store,
    private activeModal: NgbActiveModal,
    private router: Router
  ) {
  }

  ngOnDestroy(): void {
    this.store.dispatch(new GetPaycardDetail(null));
  }

  onResetPin(paycardId: string) {
    this.store.dispatch(new RequestConfirmation('home.paycards.details.confirmation.reset-pin')).toPromise()
      .then(() => {
        this.store.dispatch(new ResetPaycardPin(paycardId)).toPromise().then(() => this.activeModal.close());
      });
  }

  onDeletePaycard(paycardId: string) {
    this.store.dispatch(new RequestConfirmation('home.paycards.details.confirmation.reset-pin')).toPromise()
      .then(() => {
        this.store.dispatch(new DeletePaycard(paycardId)).toPromise().then(() => this.activeModal.close());
      });
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }
}
